import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ncs-chart-table',
  templateUrl: './ncs-chart-table.component.html',
  styleUrls: ['./ncs-chart-table.component.scss'],
})
export class NcsChartTableComponent implements OnChanges {
  @Input() data!: any; // Input for chart data
  public tableData!: any;

  ngOnChanges(changes: SimpleChanges): void {
    // Check if data has changed

    if (changes['data']) {
      this.tableData = this.getTableData();
    }
  }
  getTableData(): {
    labels: string[];
    datasets: { label: string; data: number[] }[];
  } {
    console.log(this.data);

    const labels = (this.data.labels as string[]) || [];
    const datasets = this.data.datasets.map((dataset: any) => ({
      label: dataset.label || '',
      data: dataset.data as number[],
    }));
    return { labels, datasets };
  }
}
